import React from "react";

import { ANCHOR_IDS } from "@typings/anchorIds";

import { Container } from "@components/Layout/Container";
import { Section } from "@components/Layout/Section";

import { Header } from "./Header";
import * as Styled from "./Services.styled";
import { ServicesList } from "./ServicesList";

export const Services = () => {
  return (
    <Section
      id={ANCHOR_IDS.OUR_SERVICES}
      overflowHidden
      backgroundColor="blue500"
    >
      <Container>
        <Styled.Root>
          <Header />
          <ServicesList />
        </Styled.Root>
      </Container>
    </Section>
  );
};
